import { Link } from "react-router-dom";
import { LogoBadge } from "@/components/Header";
import Footer from "@/components/Footer";
import { SEO, breadcrumbLd, webPageLd } from "@/lib/seo";

const TITLE = "Terms of Service";
const DESC =
  "The plain-English rules of using DoppelCrush — what you can do, what we can do, and what's off-limits.";

export default function Terms() {
  return (
    <div className="crush-bg min-h-screen" data-testid="terms-page">
      <SEO
        title={TITLE}
        description={DESC}
        path="/terms"
        jsonLd={[
          webPageLd({ title: TITLE, description: DESC, path: "/terms" }),
          breadcrumbLd([
            { name: "Home", path: "/" },
            { name: "Terms", path: "/terms" },
          ]),
        ]}
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-10">
        <Link to="/"><LogoBadge /></Link>
        <article className="crush-frame mt-8 p-6 sm:p-10">
          <h1 className="font-display text-5xl font-bold leading-[0.95]">
            <span className="crush-text-grad">Terms</span> of Service.
          </h1>
          <p className="mt-4 text-sm font-body text-slate-500">Last updated: 14 February 2026.</p>

          <h2 className="font-display text-2xl font-bold mt-8">1. Who can use DoppelCrush</h2>
          <p className="mt-2 font-body text-slate-700">
            You must be 18 years or older. Anyone we find to be under 18 will have their account removed.
          </p>

          <h2 className="font-display text-2xl font-bold mt-8">2. Your selfie</h2>
          <p className="mt-2 font-body text-slate-700">
            Only upload a photo of <strong>your own face</strong>. Don&apos;t upload anyone else&apos;s photo, a celebrity, a
            cartoon, or anything misleading. Catfishing gets you removed immediately.
          </p>

          <h2 className="font-display text-2xl font-bold mt-8">3. Be respectful</h2>
          <ul className="mt-2 list-disc pl-5 space-y-1.5 font-body text-slate-700">
            <li>No harassment, hate speech, threats or slurs.</li>
            <li>No nudity, explicit content, or anything sexual involving minors.</li>
            <li>No scams, MLM pitches, or financial solicitations.</li>
            <li>No off-platform recruitment for adult or escort services.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold mt-8">4. We can remove anything</h2>
          <p className="mt-2 font-body text-slate-700">
            We may suspend or delete any account that breaks these terms, at our sole discretion,
            without notice. Decisions can be appealed via <a href="mailto:hello@doppelcrush.com" className="text-pink-600 underline">hello@doppelcrush.com</a>.
          </p>

          <h2 className="font-display text-2xl font-bold mt-8">5. Your content</h2>
          <p className="mt-2 font-body text-slate-700">
            You keep all rights to your selfie and your messages. You grant DoppelCrush a limited
            license to display them inside the app to other users you interact with (matches, Doppel
            Rooms, shared twin pages). We don&apos;t use your content for anything else.
          </p>

          <h2 className="font-display text-2xl font-bold mt-8">6. The product changes</h2>
          <p className="mt-2 font-body text-slate-700">
            DoppelCrush is an evolving product. We may add, remove or reshape features without
            warning. If we make a material change to these terms we&apos;ll surface it in the app.
          </p>

          <h2 className="font-display text-2xl font-bold mt-8">7. No warranty</h2>
          <p className="mt-2 font-body text-slate-700">
            DoppelCrush is provided as-is. We can&apos;t guarantee matches, uptime, or any specific
            outcome. Use the app responsibly.
          </p>

          <h2 className="font-display text-2xl font-bold mt-8">8. Contact</h2>
          <p className="mt-2 font-body text-slate-700">
            Email <a href="mailto:hello@doppelcrush.com" className="text-pink-600 underline">hello@doppelcrush.com</a> with any question about these terms.
            Read also our <Link to="/privacy" className="text-pink-600 underline">Privacy Policy</Link>.
          </p>
        </article>
      </div>
      <Footer />
    </div>
  );
}
